import React from "react";
import "./ReligiousTrip.css";
import VaranasiSpiritualJourney from "../../assets/VaranasiSpiritualJourney.png";
import GoldenTempleVisit from "../../assets/GoldenTempleVisit.png";
import KedarnathPilgrimage from "../../assets/KedarnathPilgrimage.png";
import TirupatiTempleTour from "../../assets/TirupatiTempleTour.png";
import MeccaUmrahJourney from "../../assets/MeccaUmrahJourney.png";
import BodhGayaMeditationTour from "../../assets/BodhGayaMeditationTour.png";
import { useNavigate } from "react-router-dom";

const religiousTrips = [
  {
    title: "Varanasi Spiritual Journey",
    image: VaranasiSpiritualJourney,
    description:
      "Experience the spiritual essence of Varanasi with sacred river rituals and ancient temples. Witness mesmerizing evening ceremonies, explore historic ghats, and immerse yourself in devotional traditions during this peaceful pilgrimage.",
    link: "/tour-package-data",
  },
  {
    title: "Golden Temple Visit",
    image: GoldenTempleVisit,
    description:
      "Visit the serene Golden Temple and experience spiritual harmony through prayer and community service. Enjoy peaceful surroundings, devotional music, and the warmth of shared meals during this meaningful religious journey.",
    link: "/tour-package-data",
  },
  {
    title: "Kedarnath Pilgrimage",
    image: KedarnathPilgrimage,
    description:
      "Embark on a sacred journey to Kedarnath surrounded by majestic Himalayan landscapes. Seek blessings at the holy shrine, experience spiritual devotion, and connect deeply with nature during this memorable pilgrimage.",
    link: "/tour-package-data",
  },
  {
    title: "Tirupati Temple Tour",
    image: TirupatiTempleTour,
    description:
      "Discover divine blessings at Tirupati Temple while experiencing vibrant devotional traditions and peaceful surroundings. Participate in sacred rituals, admire temple architecture, and feel spiritual positivity throughout your journey.",
    link: "/tour-package-data",
  },
  {
    title: "Mecca Umrah Journey",
    image: MeccaUmrahJourney,
    description:
      "Undertake a spiritually fulfilling Umrah journey to Mecca filled with prayer and devotion. Experience unity, sacred rituals, and profound faith while seeking blessings during this transformative pilgrimage.",
    link: "/tour-package-data",
  },
  {
    title: "Bodh Gaya Meditation Tour",
    image: BodhGayaMeditationTour,
    description:
      "Visit Bodh Gaya, the place of enlightenment, and experience peaceful meditation sessions. Explore sacred monasteries, learn about spiritual teachings, and embrace calmness during this reflective religious journey.",
    link: "/tour-package-data",
  },
];

const ReligiousTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="religious-container">
      <h2 className="religious-title">Religious Trip Packages</h2>

      <div className="religious-grid">
        {religiousTrips.map((trip, index) => (
          <div
            className="religious-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="religious-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReligiousTrip;
